module.exports = __webpack_public_path__ + "img/no_1.1927f735.png";